<template>
  <div class="c-product-carousel-card">
    <badge
      v-if="isClearanceItem"
      class="c-badge__align-top-left"
      background-class="u-background-color-primary"
    >
      Clearance
    </badge>
    <!--    to path below is for attribution for Nosto-->
    <nuxt-link
      class="t-link-container"
      :to="nosto ? url + '?nosto=' + nostoQueryStr : url"
    >
      <card-image
        class="c-product-carousel-card__image u-margin-bottom-xx-small"
        :src="productImage"
        :alt="productImageAlt || title + ' image'"
        @mouseover.native="productImage = productHoverImage, productImageAlt = productHoverImageAlt"
        @mouseleave.native="productImage = image, productImageAlt = imageAlt"
      />

      <p
        v-if="availableColors"
        class="t-heading-10 u-margin-bottom-xx-small"
      >
        {{ availableColors }} colors available
      </p>
      <p
        v-if="subtitle"
        class="t-heading-10 u-margin-bottom-xx-small"
      >
        {{ subtitle }}
      </p>
      <p class="t-heading-6 u-margin-bottom-xx-small">
        {{ title }}
      </p>
      <div class="l-flex">
        <product-price
          :price="price"
          :compare-at-price="originalPrice"
        />
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import CardImage from './CardImage'
import ProductPrice from "../productPrice/ProductPrice";
import Badge from '../badge/Badge'
export default {
  name: 'ProductCard',
  // eslint-disable-next-line vue/require-prop-types
  components: {
    Badge,
    ProductPrice,
    CardImage,
  },
  props: {
    availableColors: {
      type: Number,
      default: null
    },
    hoverImage: {
      type: String,
      default: null,
    },
    hoverImageAlt: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    imageAlt: {
      type: String,
      default: null
    },
    originalPrice: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: null
    },
    tags: {
      type: Array,
      default: () => []
    },
    nosto: {
      type: Boolean,
      default: false
    },
    nostoQueryStr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      productImage: '',
      productImageAlt: '',
      productHoverImage: '',
      productHoverImageAlt: '',
    };
  },
  computed: {
    isClearanceItem() {
      return this.tags && this.tags.length && this.tags.includes('clearance')
    },
    nostoId() {
      return process.env.NOSTO_ID;
    }
  },
  watch: {
    image(value) {
      this.productImage = value
    },
    imageAlt(value) {
      this.productImageAlt = value
    },
    hoverImage(value) {
      this.productHoverImage = value
    },
    hoverImageAlt(value) {
      this.productHoverImageAlt = value
    },
  },
  created() {
    this.productImage = this.image
    this.productImageAlt = this.imageAlt
    if (this.hoverImage) {
      this.productHoverImage = this.hoverImage
      this.productHoverImageAlt = this.hoverImageAlt
    } else {
      this.productHoverImage = this.image
      this.productHoverImageAlt = this.imageAlt
    }
  }
}
</script>

<style lang="scss" scoped>
.c-product-carousel-card {
  width: rem(180px);
  text-align: center;
  padding-bottom: rem(5px);
  margin: auto;
  position: relative;

  &:hover {
    cursor: pointer;
  }
  &__image {
    max-width: 100%;
    max-height: 50%;
    height: 50%;
  }

  .l-flex {
    p {
      &:not(:last-child) {
        margin-right: rem(5px);
      }
    }
  }
}
</style>
